import { Link, Toolbar, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
}));
const PrivPolLink = ({}) => {
  const trackEvent = useTrackEvent()

  const classes = useStyles()
  return (
    <Toolbar disableGutters dense >
      <Typography variant='body2' color='textSecondary'>
        By continuing, you agree to our 
        {' '}<Link
        onClick={()=>trackEvent('Privacy Policy link opened')}
         href='https://www.zennya.com/privacy-policy' target='_blank'>Privacy Policy</Link>{' '}
        and
        {' '}<Link
        onClick={()=>trackEvent('TOS link opened')}
         href='https://www.zennya.com/legal/terms-of-service' target='_blank'>Terms of Service.</Link>{' '}
      </Typography>
    </Toolbar>
  )
}

export {PrivPolLink}